import { useEffect, useState } from 'react'
import { supabase } from '../api';
import useUser from 'sdk/hooks/user/useUser'

export const useUserEntryCount = () => {
  const [entryCount, setEntryCount] = useState<number>(0)
  const { data: currentUser } = useUser()
  const userId = currentUser?.user?.id

  const incrementEntryCount = async () => {
    if (!userId) {
      console.log('No userId found - user not logged in')
      return
    }
    console.log('User ID:', userId)

    // Проверяем существование профиля перед работой с user_entry_count
    const { data: profileExists, error: profileError } = await supabase
      .from('user_profiles')
      .select('id')
      .eq('id', userId)
      .maybeSingle()

    if (profileError) {
      console.error('Error checking profile existence:', profileError)
      return 0
    }

    if (!profileExists) {
      console.warn('User profile does not exist yet, skipping entry count')
      return 0
    }

    const { data: lastEntry } = await supabase
      .from('user_entry_count')
      .select('created_at, count')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .limit(1)
      .single()

    const now = new Date()
    const lastEntryTime = lastEntry ? new Date(lastEntry.created_at) : null
    const fiveMinutesAgo = new Date(now.getTime() - 5 * 60000)
    //5 * 60000 = 5 minutes
    //1 * 1000 = 1 second

    if (!lastEntryTime || lastEntryTime < fiveMinutesAgo) {
      const newCount = (lastEntry?.count || 0) + 1
      const { data, error } = await supabase
        .from('user_entry_count')
        .upsert(
          {
            user_id: userId,
            count: newCount,
            created_at: now.toISOString()
          },
          { onConflict: 'user_id' }
        )

      if (error) {
        console.error('Supabase error:', error)
        return 0
      }

      if (!error) {
        setEntryCount(newCount)
        return newCount
      }
    }
    return lastEntry?.count || 0
  }

  useEffect(() => {
    const fetchEntryCount = async () => {
      if (!userId) return

      const { data, error } = await supabase
        .from('user_entry_count')
        .select('count')
        .eq('user_id', userId)
        .single()

      if (!error && data) {
        setEntryCount(data.count)
      }
    }

    fetchEntryCount()
  }, [userId])

  return { entryCount, incrementEntryCount }
}